import axiosPost from "./axiosPost";

export const RNHDivisionIns = async (credentials, data) => {
    const body = {
        service: "RNHDivisionIns",
        params: {
            rnhDivisionCod: data?.cod || null,
            rnhDivisionNombre: data?.name || null,
            rnhDivisionDescripcion: data?.desc || null
        },
    };

    const result = await axiosPost(body, credentials);
    if(result?.status?.code === 0) {
        return [result.status]
    } else {
        return result.result;
    }
};
